import { render, staticRenderFns } from "./CompanyApproval.vue?vue&type=template&id=2770512c&scoped=true&"
import script from "./CompanyApproval.vue?vue&type=script&lang=js&"
export * from "./CompanyApproval.vue?vue&type=script&lang=js&"
import style0 from "./CompanyApproval.vue?vue&type=style&index=0&id=2770512c&prod&scoped=true&lang=css&"
import style1 from "./CompanyApproval.vue?vue&type=style&index=1&id=2770512c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2770512c",
  null
  
)

export default component.exports